module.exports = __webpack_public_path__ + "img/全⾯的云边端协同计算能⼒.f9e17ea2.png";